import { useEffect } from "react";

interface UseReleaseToolWithoutSelectionOptions {
  isActive: boolean;
  hasSelection: boolean;
  /** 도구 선택 해제 — 보통 `selectButton("")` */
  release: () => void;
}

/**
 * 선택된 피처가 있어야 쓰는 편집 도구(꼭짓점 수정·이동)가 활성 중에 선택을 잃으면(툴바 삭제·재클릭 해제)
 * 도구를 해제한다 — 버튼이 disabled 로 잠기면서 활성 표시가 남는 것을 막는다.
 */
export function useReleaseToolWithoutSelection({
  isActive,
  hasSelection,
  release,
}: UseReleaseToolWithoutSelectionOptions) {
  useEffect(() => {
    if (isActive && !hasSelection) release();
  }, [isActive, hasSelection, release]);
}
